"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMonospace = exports.setBulkVisible = exports.setWrapWidth = exports.setAlpha = exports.setTint = exports.setScale = exports.setVisible = exports.updateAll = exports.killBulk = exports.kill = exports.setText = exports.setAlignRight = exports.moveTo = exports.getCurrentHeight = exports.setDepth = exports.create = exports.findById = void 0;
var entitiesUtils_sidecar_1 = require("../entities/entitiesUtils-sidecar");
var assert_sidecar_1 = require("../lib/assert-sidecar");
var imports_1 = require("../lib/imports");
var common_sidecar_1 = require("../main/common-sidecar");
var fontData2_sidecar_1 = require("./fontData2-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var objs = [];
function findById(id) {
    return entitiesUtils_sidecar_1.entitiesUtils.findById(id, objs);
}
exports.findById = findById;
function create(font, x, y, layer) {
    if (x === void 0) { x = 0; }
    if (y === void 0) { y = 0; }
    var id = common_sidecar_1.common.createId();
    // if (!layer) {
    //   asser
    //   // layer = underLayers.getLayers().ui
    // }
    var obj = {
        eType: 'stevie-text',
        id: id,
        idLoaded: 0,
        images: [],
        visibleImages: 0,
        isDead: false,
        text: '',
        font: font,
        x: x,
        y: y,
        layer: layer,
        tint: 0xffffff,
        alpha: 1,
        monospace: false,
        isVisible: true,
        scale: 1,
        wrapWidth: 500,
        isAlignRight: false,
        curHeight: 0,
    };
    objs.push(obj);
    return obj;
}
exports.create = create;
function setDepth(obj, depth) {
    for (var i = 0; i < obj.images.length; i++) {
        var c = obj.images[i];
        c.depth = depth;
    }
}
exports.setDepth = setDepth;
function getCurrentHeight(obj) {
    return obj.curHeight;
}
exports.getCurrentHeight = getCurrentHeight;
function moveTo(obj, x, y) {
    var dx = x - obj.x;
    var dy = y - obj.y;
    obj.x = x;
    obj.y = y;
    imports_1.l.forEach(obj.images, function (c) {
        c.x += dx;
        c.y += dy;
    });
}
exports.moveTo = moveTo;
function setAlignRight(obj, wrapWidth) {
    obj.isAlignRight = true;
    obj.wrapWidth = wrapWidth;
    setText(obj, obj.text, true);
}
exports.setAlignRight = setAlignRight;
function setText(obj, text, force) {
    if (force === void 0) { force = false; }
    if (text === obj.text && !force) {
        return;
    }
    obj.text = text;
    var x = obj.x;
    var y = obj.y;
    var maxX = obj.x + obj.wrapWidth;
    var isWrapped = true;
    var wrapIdx = 0;
    var wrapX = x;
    var wordWidth = 0;
    var font = obj.font;
    // Make existing images invisible
    for (var i = 0; i < obj.images.length; i++) {
        var c = obj.images[i];
        c.visible = false;
    }
    var fMonospace = fontData2_sidecar_1.fontData2.getLetter(font, '0');
    assert_sidecar_1.assert.notNil(fMonospace);
    var imageScale = obj.scale / (fMonospace.frame.s || 1);
    var onNewline = function () {
        if (obj.isAlignRight) {
            var alignX = maxX - x;
            for (var i = wrapIdx; i < obj.images.length; i++) {
                var image = obj.images[i];
                image.x += alignX;
            }
        }
    };
    var imageIdx = 0;
    var lineHeight = font.charHeight * 1.0 * obj.scale;
    for (var i = 0; i < text.length; i++) {
        // console.log('merp', i, text)
        var letter = text[i];
        if (letter === '\n') {
            isWrapped = true;
            onNewline();
            wrapIdx = imageIdx;
            wordWidth = 0;
            x = obj.x;
            y += lineHeight;
        }
        else if (letter === ' ') {
            isWrapped = false;
            wrapIdx = imageIdx;
            wordWidth = 0;
            if (obj.monospace) {
                x += fMonospace.w * obj.scale;
            }
            else {
                x += font.spaceWidth * obj.scale;
            }
            wrapX = x;
        }
        else {
            var f = fontData2_sidecar_1.fontData2.getLetter(font, letter);
            if (f) {
                var tx = x;
                if (obj.monospace) {
                    tx += (fMonospace.w - f.w) * obj.scale;
                }
                if (imageIdx >= obj.images.length) {
                    var newImage = spritesUtil_sidecar_1.spritesUtil.createImage(obj.layer, f.frame);
                    newImage.tint = obj.tint;
                    newImage.setAlpha(obj.alpha);
                    // newImage.alpha = obj.alpha
                    obj.images.push(newImage);
                }
                else {
                    spritesUtil_sidecar_1.spritesUtil.setPackedFrame(obj.images[imageIdx], f.frame);
                }
                var image = obj.images[imageIdx];
                image.x = tx + f.leading * obj.scale;
                image.y = y + f.oy * obj.scale;
                image.visible = obj.isVisible;
                image.scale = imageScale;
                if (obj.monospace) {
                    f = fMonospace;
                }
                var letterW = f.w * obj.scale + font.charSpacing * obj.scale;
                wordWidth += letterW;
                x += letterW;
                imageIdx++;
            }
            else {
                var letterW = font.spaceWidth * obj.scale;
                wordWidth += letterW;
                x += letterW;
                console.warn('missing font letter', letter);
            }
            if (x > maxX) {
                if (!isWrapped) {
                    onNewline();
                    var left = wrapX - obj.x;
                    x = obj.x + wordWidth;
                    y += lineHeight;
                    for (var iWrap = wrapIdx; iWrap < obj.images.length && iWrap <= imageIdx; iWrap++) {
                        var imageWrap = obj.images[iWrap];
                        imageWrap.y += lineHeight;
                        imageWrap.x -= left;
                        // x = imageWrap.x
                    }
                    isWrapped = true;
                }
            }
        }
    }
    obj.visibleImages = imageIdx;
    obj.curHeight = y - obj.y;
    if (obj.curHeight < lineHeight) {
        obj.curHeight = lineHeight;
    }
    onNewline();
}
exports.setText = setText;
function kill(obj) {
    if (!obj) {
        return;
    }
    obj.isDead = true;
}
exports.kill = kill;
function killBulk(objs) {
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    return [];
}
exports.killBulk = killBulk;
function updateAll() {
    // objs.forEach((c) => {
    //   // update(c)
    // })
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        c.images.forEach(function (d) {
            d.destroy();
        });
    });
}
exports.updateAll = updateAll;
// function textCreateImageFromFrame(
//   layer: Layer,
//   frame: Phaser.Textures.Frame,
//   x: number,
//   y: number,
//   scale: number = 1,
// ) {
//   let phaserScene = common.getPhaserScene()
//   let image = phaserScene.add.image(0, 0, '')
//   layer.add(image)
//   image.width = frame.width
//   image.height = frame.height
//   image.frame = frame
//   image.originX = 0.5
//   image.originY = 0.5
//   image.x = x
//   image.y = y
//   if (scale) {
//     image.setScale(scale)
//   }
//   image.setDisplayOrigin(0, 0)
//   return image
// }
function setVisible(obj, visible) {
    obj.isVisible = visible;
    for (var i = 0; i < obj.images.length; i++) {
        var c = obj.images[i];
        c.visible = visible && i < obj.visibleImages;
    }
}
exports.setVisible = setVisible;
function setScale(obj, newScale) {
    if (obj.scale !== newScale) {
        obj.scale = newScale;
        setText(obj, obj.text, true);
    }
}
exports.setScale = setScale;
function setTint(obj, tint) {
    obj.tint = tint;
    for (var i = 0; i < obj.images.length; i++) {
        var c = obj.images[i];
        c.tint = tint;
    }
}
exports.setTint = setTint;
function setAlpha(obj, a) {
    obj.alpha = a;
    for (var i = 0; i < obj.images.length; i++) {
        var c = obj.images[i];
        c.setAlpha(a);
        // c.alpha = a
    }
}
exports.setAlpha = setAlpha;
function setWrapWidth(obj, w) {
    if (w !== obj.wrapWidth) {
        obj.wrapWidth = w;
        setText(obj, obj.text, true);
    }
}
exports.setWrapWidth = setWrapWidth;
function setBulkVisible(objs, isVisible) {
    imports_1.l.forEach(objs, function (c) { return setVisible(c, isVisible); });
}
exports.setBulkVisible = setBulkVisible;
function setMonospace(obj, monospace) {
    obj.monospace = monospace;
    setText(obj, obj.text, true);
}
exports.setMonospace = setMonospace;
